import { Component, ViewChild } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { MakingTecaPost } from '../../../shared/interface';
import { ConfirmPopup } from 'primeng/confirmpopup';
import { ConfirmationService } from 'primeng/api';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-making-teca-backoffice',
  templateUrl: './making-teca-backoffice.component.html',
  styleUrl: './making-teca-backoffice.component.css'
})
export class MakingTecaBackofficeComponent {
  
  constructor(private apiService: ApiService, private confirmationService: ConfirmationService) { }

  @ViewChild("deletePost") deletePost!: ConfirmPopup;

  making_teca_posts: MakingTecaPost[] = [];
  loading: boolean = false;

  ngOnInit(): void {

    this.loading = true;

    this.apiService.setMakingTecaPosts();
    this.apiService.makingTecaPostChanged.subscribe({
      next: (data) => {
        this.making_teca_posts = [...data];
        this.loading = false;
      },
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message)      
    })

  }

  onGlobalFilter(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  onOpenDeletePost(event: Event, post: MakingTecaPost) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: "Sei sicuro di voler eliminare il post?",
      reject: () => this.confirmationService.close(),
      accept: () => {
        this.apiService.deleteMakingTecaPost(post.id).subscribe({
          next: (data) => this.apiService.setMakingTecaPosts(),
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
          complete: () => {
            this.confirmationService.close()
            this.apiService.message("success", "Eliminazione", "Il post è stato eliminato con successo")
          }
        })
      }
    });
  }

  onDeletePost() {    
    this.deletePost.accept();
  }

  onAnnullaDeletePost() {
    this.deletePost.reject();
  }

}
